export default "__VITE_ASSET__DJNW3AFb__";